// reduxjs toolkit
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BaseUrl from '../../service/API/base_url';
import { handleSuccess, handleError } from '../../utils/toast';
//List all Bookings

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

export const viewBooking = createAsyncThunk('booking', async thunkAPI => {
  try {
    let response = await axios.get(`${BaseUrl}dorm-api/bookings`);
    if (response.status === 200) {
      return response.data;
    } else {
      handleError(response.message);
      return thunkAPI.rejectWithValue(response.data);
    }
  } catch (e) {
    handleError('loading...');
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

//Add new Booking
export const registerBooking = createAsyncThunk(
  'booking',
  async (bookingData, thunkAPI) => {
    // console.log('revice request data in action page : ', bookingData);
    try {
      let URL = `${BaseUrl}dorm-api/bookings`;
      let response = await axios.post(URL, bookingData);
      //condition
      if (response.status === 201) {
        handleSuccess('Request sent successfull!');
        return response.data;
      } else {
        handleError(response.data.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
//search Booking
export const singleBooking = createAsyncThunk(
  'booking',
  async (id, thunkAPI) => {
    try {
      // response
      let response = await axios.get(`${BaseUrl}dorm-api/bookings/${id}`);
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError('searching error...');
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
// update Booking
export const updateBooking = createAsyncThunk(
  'booking',
  async (bookingData, thunkAPI) => {
    try {
      // response
      let response = await axios.put(
        `${BaseUrl}dorm-api/bookings/${bookingData.id}`,
        bookingData.formData,
      );
      // condition
      if (response.status === 200) {
        handleSuccess('Change successfull');
        return response.data.booking;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
// Search Booking
export const deleteBooking = createAsyncThunk(
  'booking',
  async (id, thunkAPI) => {
    try {
      const userInfo = localStorage.getItem('userInfo')
        ? JSON.parse(localStorage.getItem('userInfo'))
        : null;
      //respone
      let response = await axios.delete(`${BaseUrl}dorm-api/booking/${id}`, {
        headers: { Authorization: `Bearer ${userInfo}` },
      });
      //conditoon
      if (response.status === 200) {
        handleSuccess('Delete successfull!');
        return response.data.Bookings;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError(e.response.data.message);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

//search request by single user
export const singleUserBooking = createAsyncThunk(
  'booking',
  async (id, thunkAPI) => {
    try {
      // response
      let response = await axios.get(`${BaseUrl}dorm-api/user-bookings/${id}`);
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError('searching error...');
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

//get all landlord request from order table
export const getLandlordHouseRequestById = createAsyncThunk(
  'booking',
  async (id, thunkAPI) => {
    try {
      // response
      let response = await axios.get(
        `${BaseUrl}dorm-api/landlord-request-list/${id}`,
      );
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError('searching error...');
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

//get single house request from order table
export const getSingleHouseRequestList = createAsyncThunk(
  'booking',
  async (id, thunkAPI) => {
    try {
      // response
      let response = await axios.get(
        `${BaseUrl}dorm-api/single-house-request-list/${id}`,
      );
      if (response.status === 200) {
        return response.data;
      } else {
        handleError(response.message);
        return thunkAPI.rejectWithValue(response.data);
      }
    } catch (e) {
      handleError('searching error...');
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

// select a single user from all house request list
export const selectUserFromRequest = createAsyncThunk(
  'booking',
  async (RequestData, thunkAPI) => {
    const token = JSON.parse(localStorage.getItem('userInfo')) || null;
    console.log('request data : ', RequestData);
    try {
      const response = await axios.put(
        `${BaseUrl}dorm-api/accept-request/${RequestData.id}`,
        RequestData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      return handleApiResponse(response, thunkAPI, 'Select user successfully!');
    } catch (e) {
      return handleApiError(
        e,
        thunkAPI,
        'Please try again. Invalid credentials',
      );
    }
  },
);
